import React from 'react'
import classNames from 'classnames'
import { isNil } from 'lodash'
import { Droppable } from 'react-beautiful-dnd'

import { Tag } from './Tag'

export const TagList = ({ column, tags, deleteTag }) => {
  return (
    <Droppable droppableId={column.id.toString()} direction="horizontal" type="task">
      {(provided, snapshot) => (
        <div
          className={classNames('manage-tags__tag-list', {
            'dragging-over': snapshot.isDraggingOver,
          })}
          data-testid="tag-list"
          ref={provided.innerRef}
          {...provided.droppableProps}
        >
          {tags
            .filter((tag) => !isNil(tag?.id))
            .map((tag, index) => (
              <Tag key={tag.id} tag={tag} index={index} deleteTag={deleteTag} />
            ))}
          {provided.placeholder}
        </div>
      )}
    </Droppable>
  )
}
